import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@repo/ui/components/Base/Dialog";
import { CreateUserForm } from "./CreateUserForm";
import type { UserWRole } from "@repo/types";

import { CreateTriggerButton } from "@repo/ui/components/Base/CreateTriggerButton";

export const CreateUserDialog = ({
  tenantId,
  onCreated,
}: {
  tenantId: string;
  onCreated: (user: UserWRole) => void;
}) => {
  const [open, setOpen] = useState(false);
  const handleOpenChange = () => setOpen(!open);
  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger
        asChild
        className="flex flex-row gap-2 p-2 rounded-lg hover:scale-110 duration-100 shadow-2xl"
      >
        <CreateTriggerButton />
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create a New User</DialogTitle>
        </DialogHeader>
        <CreateUserForm
          tenantId={tenantId}
          handleCancel={handleOpenChange}
          handleComplete={(user) => {
            handleOpenChange();
            onCreated(user);
          }}
          withinDialog
        />
      </DialogContent>
    </Dialog>
  );
};
